import { encryptData } from "../../functions/cryptoUtils"

export const filterComprobante = (comprobantes: any[]) => {
    return {
        type: "FILTER_GRID_COMPROBANTE",
        payload: encryptData(comprobantes)
    }
}

